"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var kiwi = require("kiwi.js");
var _ = require("lodash");
var fbemitter_1 = require("fbemitter");
var Solver = /** @class */ (function (_super) {
    __extends(Solver, _super);
    function Solver() {
        var _this = _super.call(this) || this;
        _this.kiwiSolver = new kiwi.Solver();
        _this.variables = {};
        _this.constraintGroups = {};
        _this.nextId = 0;
        return _this;
    }
    Solver.prototype.getVariableValue = function (variableName) {
        var variable = this.variables[variableName];
        if (variable) {
            return variable.kiwiVariable.value();
        }
        else {
            return undefined;
        }
    };
    Solver.prototype.getVariableValues = function () {
        return _.mapValues(this.variables, function (variableInSolver) { return variableInSolver.kiwiVariable.value(); });
    };
    Solver.prototype.setConstraints = function (groupName, constraints) {
        var _this = this;
        var oldGroup = this.constraintGroups[groupName];
        // First, check if the list is unchanged. I didn't think this would be
        // important, but it seems to prevent enormous amounts of jank. Huh...
        if (!oldGroup && constraints.length === 0) {
            return;
        }
        if (oldGroup) {
            var oldConstraints = _.map(oldGroup, 'constraint');
            if (_.isEqual(constraints, oldConstraints)) {
                return;
            }
            else {
                // console.log("Changes in ", groupName)
                // console.log("  Added", _.differenceWith(constraints, oldConstraints, _.isEqual).map(Constraint.toString))
                // console.log("  Removed", _.differenceWith(oldConstraints, constraints, _.isEqual).map(Constraint.toString))
                // ;(window as any).oldConstraints = oldConstraints
                // ;(window as any).newConstraints = constraints
            }
        }
        var newGroup = [];
        // NOTE: It is very important to remove old specs before adding new ones.
        // Otherwise, intermediate inconsistencies are possible. (I'm not sure if
        // this is the best approach in the long run.)
        // Remove old specs, if necessary
        if (oldGroup) {
            oldGroup.forEach(function (constraintInSolver) {
                _this.removeConstraintInSolver(constraintInSolver);
            });
        }
        // Add new specs
        constraints.forEach(function (constraint) {
            newGroup.push(_this.addConstraint(constraint));
        });
        if (constraints.length > 0) {
            this.constraintGroups[groupName] = newGroup;
        }
        else {
            delete this.constraintGroups[groupName];
        }
        this.kiwiSolver.updateVariables();
        this.emit('change');
    };
    // This isn't used by the kiwifruit solver. It just turns out to be a nice
    // thing for a solver to provide to its users.
    Solver.prototype.newId = function () {
        var curId = this.nextId;
        this.nextId++;
        return curId;
    };
    Solver.prototype.addConstraint = function (constraint) {
        var _this = this;
        var _a;
        var expression = constraint.expression, operator = constraint.operator, strength = constraint.strength;
        var expressionArgs = [];
        _.forEach(expression.terms, function (coefficient, variableName) {
            var variableInSolver = _this.referToVariableByName(variableName);
            expressionArgs.push([coefficient, variableInSolver.kiwiVariable]);
        });
        expressionArgs.push(expression.constant);
        var kiwiExpression = new ((_a = kiwi.Expression).bind.apply(_a, [void 0].concat(expressionArgs)))();
        var kiwiConstraint = new kiwi.Constraint(kiwiExpression, operator, undefined, strength);
        this.kiwiSolver.addConstraint(kiwiConstraint);
        return { kiwiConstraint: kiwiConstraint, constraint: constraint };
    };
    Solver.prototype.referToVariableByName = function (variableName) {
        var variableInSolver = this.variables[variableName];
        if (!variableInSolver) {
            variableInSolver = this.variables[variableName] = {
                kiwiVariable: new kiwi.Variable(variableName),
                referenceCount: 0
            };
        }
        variableInSolver.referenceCount++;
        return variableInSolver;
    };
    Solver.prototype.removeConstraintInSolver = function (constraintInSolver) {
        var _this = this;
        this.kiwiSolver.removeConstraint(constraintInSolver.kiwiConstraint);
        _.forEach(constraintInSolver.constraint.expression.terms, function (_coefficient, variableName) {
            _this.decrementVariableReferenceCount(variableName);
        });
    };
    Solver.prototype.decrementVariableReferenceCount = function (variableName) {
        var variable = this.variables[variableName];
        variable.referenceCount--;
        if (variable.referenceCount === 0) {
            delete this.variables[variableName];
        }
    };
    return Solver;
}(fbemitter_1.EventEmitter));
exports.Solver = Solver;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../kiwifruit/kiwifruit-solver/build/index.js
// module id = 81
// module chunks = 0